import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import { store } from "@/store";
import { AuthGetters } from "@/store/modules/auth";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/LayoutDashboard.vue"),
    meta: { auth: true },
    children: [
      {
        path: "",
        redirect: { name: "Dashboard" },
        meta: { auth: true },
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/pages/dashboard/DashboardPage.vue"),
        meta: { auth: true },
      },
      {
        path: "platform/tenants",
        name: "TenantManagement",
        component: () => import("@/views/platform/TenantManagement.vue"),
        meta: { auth: true, platformAdmin: true },
      },
      {
        path: "companies",
        name: "CompanyList",
        component: () => import("@/views/companies/Company.vue"),
        meta: { auth: true },
      },
      {
        path: "/companies/create",
        name: "CompanyCreate",
        component: () => import("@/views/companies/Company.vue"),
        meta: { auth: true },
      },
      {
        path: "/companies/:id",
        name: "CompanyDetails",
        component: () => import("@/views/companies/CompanyDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "/companies/update/:id",
        name: "CompanyEdit",
        component: () => import("@/views/companies/Company.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "jobs",
        name: "JobList",
        component: () => import("@/views/job/JobList.vue"),
        meta: { auth: true },
      },
      {
        path: "jobs/create",
        name: "JobCreate",
        component: () => import("@/views/job/JobForm.vue"),
        meta: { auth: true },
      },
      {
        path: "jobs/:id",
        name: "JobDetails",
        component: () => import("@/views/job/JobDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "jobs/update/:id",
        name: "JobEdit",
        component: () => import("@/views/job/JobForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/views/user/Profile.vue"),
        meta: { auth: true },
      },
      {
        path: "transfer-authority",
        name: "TransferAuthority",
        component: () => import("@/views/user/TransferAuthority.vue"),
        meta: { auth: true },
      },
      {
        path: "entity-approval",
        name: "EntityApprovalList",
        component: () =>
          import("@/views/entityApproval/EntityApprovalList.vue"),
        meta: { auth: true },
      },
      {
        path: "entity-approval/:id",
        name: "EntityApprovalDetails",
        component: () =>
          import("@/views/entityApproval/EntityApprovalDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "notifications",
        name: "Notifications",
        component: () => import("@/views/Notifications.vue"),
        meta: { auth: true },
      },
      {
        path: "helpdesk",
        name: "Helpdesk",
        component: () => import("@/views/helpdesk/HelpdeskPage.vue"),
        meta: { auth: true },
      },
      {
        path: "users",
        name: "UserList",
        component: () => import("@/views/user/UserList.vue"),
        meta: { auth: true },
      },
      {
        path: "users/create",
        name: "UserCreate",
        component: () => import("@/views/user/UserForm.vue"),
        meta: { auth: true },
      },
      {
        path: "users/:id",
        name: "UserDetails",
        component: () => import("@/views/user/UserDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "users/update/:id",
        name: "UserEdit",
        component: () => import("@/views/user/UserForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "roles",
        name: "RoleList",
        component: () => import("@/views/role/RoleList.vue"),
        meta: { auth: true },
      },
      {
        path: "roles/create",
        name: "RoleCreate",
        component: () => import("@/views/role/RoleForm.vue"),
        meta: { auth: true },
      },
      {
        path: "roles/:id",
        name: "RoleDetails",
        component: () => import("@/views/role/RoleDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "roles/update/:id",
        name: "RoleEdit",
        component: () => import("@/views/role/RoleForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "logs",
        name: "Logs",
        component: () => import("@/views/logs/Logs.vue"),
        meta: { auth: true },
      },
      {
        path: "reports",
        name: "reports",
        component: () => import("@/views/Reports.vue"),
        meta: { auth: true },
      },
      {
        path: "hr",
        name: "HrEmployeeList",
        component: () => import("@/views/hr/HrEmployeeList.vue"),
        meta: { auth: true, permission: "HR_VIEW" },
      },
      {
        path: "hr/employees/create",
        name: "HrEmployeeCreate",
        component: () => import("@/views/hr/HrEmployeeForm.vue"),
        meta: { auth: true, permission: "HR_EMPLOYEE_EDIT" },
      },
      {
        path: "hr/employees/:id",
        name: "HrEmployeeDetails",
        component: () => import("@/views/hr/HrEmployeeDetails.vue"),
        meta: { auth: true, permission: "HR_VIEW" },
      },
      {
        path: "hr/employees/:id/edit",
        name: "HrEmployeeEdit",
        component: () => import("@/views/hr/HrEmployeeForm.vue"),
        meta: { auth: true, permission: "HR_EMPLOYEE_EDIT" },
      },
      {
        path: "hr/settings",
        name: "HrSettings",
        component: () => import("@/views/hr/HrSettings.vue"),
        meta: { auth: true, permission: "HR_SETTINGS_MANAGE" },
      },
      {
        path: "hr/audit",
        name: "HrAudit",
        component: () => import("@/views/hr/HrAudit.vue"),
        meta: { auth: true, permission: "HR_VIEW" },
      },
      {
        path: "hr/analytics",
        name: "HrAnalytics",
        component: () => import("@/views/hr/HrAnalytics.vue"),
        meta: { auth: true, permission: "HR_VIEW" },
      },
      {
        path: "documents",
        name: "DocumentList",
        component: () => import("@/views/documents/document/DocumentList.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/nomenclature",
        name: "NomenclatureList",
        component: () =>
          import("@/views/documents/nomenclature/NomenclatureList.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/nomenclature/create",
        name: "NomenclatureCreate",
        component: () =>
          import("@/views/documents/nomenclature/NomenclatureForm.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/nomenclature/:id",
        name: "NomenclatureDetails",
        component: () =>
          import("@/views/documents/nomenclature/NomenclatureDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/nomenclature/update/:id",
        name: "NomenclatureEdit",
        component: () =>
          import("@/views/documents/nomenclature/NomenclatureForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-constructor/create",
        name: "DocumentConstructorCreate",
        component: () =>
          import(
            "@/views/documents/documentConstructor/DocumentConstructorForm.vue"
          ),
        meta: { auth: true },
      },
      {
        path: "documents/process-template",
        name: "ProcessTemplateList",
        component: () =>
          import("@/views/documents/process/template/ProcessTemplateList.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/process-template/create",
        name: "ProcessTemplateCreate",
        component: () =>
          import("@/views/documents/process/template/ProcessTemplateForm.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/process-template/update/:id",
        name: "ProcessTemplateEdit",
        component: () =>
          import("@/views/documents/process/template/ProcessTemplateForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-constructor/update/:id",
        name: "DocumentConstructorEdit",
        component: () =>
          import(
            "@/views/documents/documentConstructor/DocumentConstructorForm.vue"
          ),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-constructor/:id",
        name: "DocumentConstructorDetails",
        component: () =>
          import(
            "@/views/documents/documentConstructor/DocumentConstructorDetails.vue"
          ),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-constructor",
        name: "DocumentConstructorList",
        component: () =>
          import(
            "@/views/documents/documentConstructor/DocumentConstructorList.vue"
          ),
        meta: { auth: true },
      },
      {
        path: "documents/document",
        name: "DocumentList",
        component: () => import("@/views/documents/document/DocumentList.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/document/create",
        name: "DocumentCreate",
        component: () => import("@/views/documents/document/DocumentForm.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/document/batch-create",
        name: "DocumentBatchCreate",
        component: () =>
          import("@/views/documents/document/DocumentBatchCreate.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/document/draft-batch-edit",
        name: "DocumentDraftBatchEdit",
        component: () =>
          import("@/views/documents/document/DocumentDraftBatchEdit.vue"),
        meta: { auth: true },
      },
      {
        path: "documents/document/update/:id",
        name: "DocumentEdit",
        component: () => import("@/views/documents/document/DocumentForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document/:id",
        name: "DocumentDetails",
        component: () =>
          import("@/views/documents/document/DocumentDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-template/:id",
        name: "DocumentTemplateDetails",
        component: () =>
          import(
            "@/views/documents/documentTemplate/DocumentTemplateDetails.vue"
          ),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-template/create",
        name: "DocumentTemplateCreate",
        component: () =>
          import("@/views/documents/documentTemplate/DocumentTemplateForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-template/update/:id",
        name: "DocumentTemplateEdit",
        component: () =>
          import("@/views/documents/documentTemplate/DocumentTemplateForm.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/document-template",
        name: "DocumentTemplateList",
        component: () =>
          import("@/views/documents/documentTemplate/DocumentTemplateList.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/process-user",
        name: "ProcessUsersList",
        component: () =>
          import("@/views/documents/process/users/ProcessUsersList.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "documents/process-user/:id",
        name: "ProcessUserDetails",
        component: () =>
          import("@/views/documents/process/users/ProcessUserDetails.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "document-structure",
        name: "DocumentStructure",
        component: () => import("@/views/archive/ArchivePage.vue"),
        meta: { auth: true },
      },
      {
        path: "upload-ecp",
        name: "UploadEcp",
        component: () => import("@/views/upload-ecp/UploadEcp.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "public/external-sign/:token",
        name: "ExternalSign",
        component: () => import("@/views/external-sign/index.vue"),
        props: true,
        meta: { auth: true },
      },
      {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: {
          template: "<h1>Страница не найдено</h1>",
        },
        props: true,
        meta: { auth: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Auth",
    component: () => import("@/views/auth/Login.vue"),
    meta: { auth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn =
    store.getters[AuthGetters.GET_IS_LOGGED_IN_IN] ||
    !!localStorage.getItem("token");
  if (to.meta.auth) {
    if (isLoggedIn) {
      const identity = store.getters[AuthGetters.GET_USER_IDENTITY];
      if (to.meta.platformAdmin && identity?.platformAdmin !== true) {
        next({ name: "Dashboard" });
      } else if (
        to.meta.permission &&
        identity &&
        !identity.permissions?.includes(to.meta.permission as string)
      ) {
        next({ name: "Dashboard" });
      } else {
        next();
      }
    } else {
      next({
        name: "Auth",
        query: { redirect: to.fullPath },
      });
    }
  } else {
    if (to.name === "Auth" && isLoggedIn) {
      next({ name: "Dashboard" });
    } else if (to.name !== "Auth") {
      next({ name: "Auth" });
    } else {
      next();
    }
  }
});

export default router;
